module.exports = __webpack_public_path__ + "img/slide3.c67aa3e3.webp";